/** Small client-side id/number generators. Real primary keys (uuid) are generated
 * here because sync-api's generic CRUD route only lets Postgres default
 * `created_at`/`updated_at` — the row `id` itself is whatever the client sends. */

export function newId(): string {
  return crypto.randomUUID();
}

export function nowIso(): string {
  return new Date().toISOString();
}
